export default __webpack_public_path__ + "static/media/barSetting.svg";